__turbopack_context__.v({
  "buttons": "CategoryFilter-module-scss-module__gS9BTa__buttons",
  "filter-button": "CategoryFilter-module-scss-module__gS9BTa__filter-button",
  "filter-form": "CategoryFilter-module-scss-module__gS9BTa__filter-form",
  "filter-menu": "CategoryFilter-module-scss-module__gS9BTa__filter-menu",
});
